import { supabase } from './supabase'

/**
 * Indexa um conteúdo individual para busca semântica no chat IA.
 * Fire-and-forget — nunca bloqueia o fluxo principal.
 *
 * @param {Object} params
 * @param {number}  params.projeto_id  — ID do projeto
 * @param {string}  params.fonte       — 'notas' | 'reuniao_ata' | 'reuniao_transcricao' | 'reuniao_foto' | 'revisao_arquivo'
 * @param {string}  params.fonte_id    — ID único da fonte (nota.id, reuniao.id, path, etc.)
 * @param {string}  [params.texto]     — texto direto (para notas de texto, ata_texto, transcrição)
 * @param {string}  [params.bucket]    — bucket do storage (para arquivos)
 * @param {string}  [params.storage_path] — path no storage (para arquivos)
 * @param {string}  [params.prefixo]   — prefixo de metadata para o chunk (ex: "[Ata de Reunião REU07 — ...]")
 * @param {string}  [params.modo]      — 'apagar' para só remover chunks existentes
 */
export function indexarConteudo(params: { projeto_id: number; fonte: string; fonte_id: string | number; texto?: string; bucket?: string; storage_path?: string; prefixo?: string; modo?: string }) {
  if (!params.projeto_id || !params.fonte || !params.fonte_id) return
  supabase.functions.invoke('indexar-conteudo', { body: params })
    .catch(err => console.warn('[indexar-conteudo]', err))
}
